<script>
    import RepTable from './RepTable.svelte';
    import Photos from './../Photos.svelte';
    import Slides from './slides/Slides.svelte';
    import PrintSection from "./PrintSection.svelte";
    import RssCard from './issues/RssCard.svelte';

    import { byLocale, __, t, __c, locale } from '../../utils/i18n';
    import { districtNames } from '../../utils/copy';

    /**
     * @type {any[]}
     */
    export let data;

     /**
   * @type {boolean}
   */
   export const isCity = false;
        /**
   * @type {boolean}
   */
   export const cityName = false;
   /**
   * @type {any[]}
   */
   export let zonesContent;
  
  let headers = [
    t(districtNames, 'assembly', {id: data.assembly.id}),
    t(districtNames, 'senate', {id: data.state_senate.id}),
    "State Representatives"
  ];

    let reps = [[data.assembly],[data.state_senate], data.reps];
    reps[0][0]['office'] = 'State assemblymember';
    reps[1][0]['office'] = 'State senator';

    //fetching live
    let items = [];
    async function load(url) {
        // let headers = new Headers();
        // headers.append('Access-Control-Allow-Origin','*' );
        // headers.append('Access-Control-Allow-Credentials', 'true');
        // headers.append('Access-Control-Allow-Methods', "GET")
        const res = await fetch(url)
        const text = await res.text();

        const feed = new DOMParser().parseFromString(text, 'text/xml')
        items = [...feed.querySelectorAll('item')].slice(0,5).map(item => {
            const title = item.querySelector('title').textContent;
            const link = item.querySelector('guid').textContent;
            
            return { title, link };
        });
        // console.log("items",items)
    }
    $: feedList = load('https://www.latimes.com/homeless-housing/rss2.0.xml');

  ////reading feeds for dev or if the fetch function doesn't work 
  // const feedURL = window.DATA_URLS.feeds
  // async function feedsListed() {
  //   const d = await csv(feedURL);
  //   return d;
  // }

  // $: feedList = feedsListed();


  </script>
  
  <section>
    <div class="section state" id="state">
      <div class="title-map">
        <div class="hide-on-desktop hide-on-tablet">
          {@html byLocale(zonesContent, 'heading')}
        </div>
  
        <div class="map-wrapper">
          <div class="as-map" id="assembly-senate" />
        </div>

      </div>
      <div class="content">
        <div class="hide-on-mobile">
          {@html byLocale(zonesContent, 'heading')}
        </div>
          {@html byLocale(zonesContent, 'content')}
        <Photos
          lookup='summons'
          className = "main-page-img smaller-verticals"
          idName = ""
          ariaHidden = "false"
          lazyLoad = "false"
          />
      </div>

      <div class="content contd">
        <RepTable {reps} {headers} />
      </div>
      <Slides 
      topHed = {__("State Government")}
      title={__("What actually happens in Sacramento?")} 
      subtitle={__("A lot that affects you!")}
      level="state"
      />

    <div class="content contd">
    {#await feedList}
    <p />
    {:then p}
      {#if locale == 'en'}
        <RssCard cardTitle = "Latest news on housing and homelessness" level="state" content={items}/>
      {/if}
    {:catch error}
      <p style="color: red">{error.message}</p>
    {/await}
   </div> 

    </div>
  </section>

  <PrintSection {reps} {headers} heading={zonesContent[`${__c("heading")}`]} name={cityName} level="state" />
